import React from "react";

const Learners = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.854 37.6001C44.3268 37.6001 50.02 41.2203 53.5942 46.7192C54.2772 47.7699 54.9028 48.6535 54.8364 49.7896C54.8095 50.2494 54.6565 50.7068 54.4556 51.0913C54.255 51.4751 53.9666 51.8625 53.6021 52.145C53.1187 52.5195 52.5787 52.6693 52.0122 52.7368C51.4725 52.8011 50.8102 52.7993 50.0444 52.7993H25.6636C24.8978 52.7993 24.2355 52.8011 23.6958 52.7368C23.1294 52.6693 22.5893 52.5195 22.106 52.145C21.7414 51.8625 21.453 51.4751 21.2524 51.0913C21.0515 50.7068 20.8985 50.2494 20.8716 49.7896C20.8052 48.6536 21.43 47.7698 22.1128 46.7192C25.6871 41.2203 31.3812 37.6001 37.854 37.6001ZM37.854 12.6001C43.7651 12.6001 48.516 17.5028 48.5161 23.4995C48.5161 29.4963 43.7651 34.3999 37.854 34.3999C31.9429 34.3999 27.1919 29.4963 27.1919 23.4995C27.192 17.5028 31.9429 12.6001 37.854 12.6001Z"
        fill="url(#paint0_linear_3991_1480)"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1211 37.6001C32.5939 37.6001 38.2871 41.2203 41.8613 46.7192C42.5442 47.7699 43.1699 48.6535 43.1035 49.7896C43.0766 50.2494 42.9236 50.7068 42.7227 51.0913C42.5221 51.4751 42.2337 51.8625 41.8691 52.145C41.3858 52.5195 40.8457 52.6693 40.2793 52.7368C39.7396 52.8011 39.0773 52.7993 38.3115 52.7993H13.9307C13.1649 52.7993 12.5026 52.8011 11.9629 52.7368C11.3965 52.6693 10.8564 52.5195 10.373 52.145C10.0085 51.8625 9.72011 51.4751 9.51953 51.0913C9.31859 50.7068 9.16561 50.2494 9.13867 49.7896C9.07231 48.6536 9.69705 47.7698 10.3799 46.7192C13.9542 41.2203 19.6483 37.6001 26.1211 37.6001ZM26.1211 12.6001C32.0321 12.6001 36.7831 17.5028 36.7832 23.4995C36.7832 29.4963 32.0322 34.3999 26.1211 34.3999C20.2099 34.3999 15.459 29.4963 15.459 23.4995C15.4591 17.5028 20.21 12.6001 26.1211 12.6001Z"
        fill="url(#paint1_linear_3991_1480)"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3991_1480"
          x1="54.5264"
          y1="51.7997"
          x2="18.7478"
          y2="48.7463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3991_1480"
          x1="42.7934"
          y1="51.7997"
          x2="7.01485"
          y2="48.7463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Learners;
